<app-header-bar></app-header-bar>
<div class="limit-content mt-3" *ngIf="ad && !notCandidable">
  <h1>{{ ad?.title }}</h1>

  <ul *ngIf="ad">
    <li *ngIf="ad.startDate">
      <b>Data inizio</b>: {{ ad.startDate ?? "" | fhdate }}
    </li>
    <li *ngIf="!ad.startDate"><b>Data inizio</b>: Non disponibile</li>
    <li><b>Città</b>: {{ ad?.citta }} ({{ ad?.provincia }})</li>
    <li *ngIf="ad.zona"><b>Zona</b>: {{ ad.zona }}</li>
    <li *ngIf="!ad.zona"><b>Zona</b>: Non disponibile</li>
  </ul>

  <p [innerHTML]="ad?.descrizioneImpegno"></p>

  <div class="d-grid">
    <a
      [href]="
        'https://my.familyhappybenefit.com/dashboard/job-offers/' + requestID
      "
      target="_blank"
      rel="noopener noreferrer"
      class="btn my-3 m-auto px-3 py-2 my-5 bg-secondary text-black"
    >
      Candidati
    </a>
  </div>
</div>

<div class="limit-content not-available" style="padding: 10%" *ngIf="!ad">
  <h1>
    La selezione per questa proposta è stata completata.<br />
    Non mollare, ogni giorno pubblichiamo nuovi annunci interessanti.
  </h1>

  <div class="divider"></div>

  <div class="btn-container">
    <a routerLink="/bacheca">
      <button class="my-button" type="button">Torna agli annunci</button>
    </a>
  </div>
</div>

<div
  class="limit-content not-available"
  style="padding: 10%"
  *ngIf="notCandidable"
>
  <h1>
    Ti sei già candidata per questa offerta di lavoro, ti comunicheremo l'esito
    non appena la selezione sarà chiusa
  </h1>

  <div class="divider"></div>

  <div class="btn-container">
    <a routerLink="/bacheca">
      <button class="my-button" type="button">Torna agli annunci</button>
    </a>
  </div>
</div>
<app-modal-loader
  [openModal]="modalLoader"
  *ngIf="modalLoader"
></app-modal-loader>
<app-cookie-banner></app-cookie-banner>
